<template>
    <CardPage :section="18" :page="3" :nextDisabled="nextDisabled">
        <video controls controlslist="nodownload" @playing="playing" @ended="ended">
            <source :src="require('@/assets/videos/Video18.mp4')" type="video/mp4" />
            <track kind="captions" srclang="en" :src="require('@/assets/videos/Video18.vtt')" />
        </video>
    </CardPage>
</template>

<script>
export default {
    data() {
        return {
            videoStarted: false,
            videoCompleted: false
        };
    },
    methods: {
        nextDisabled() {
            return !(this.videoStarted && this.videoCompleted);
        },
        playing() {
            this.videoStarted = true;
        },
        ended() {
            this.videoCompleted = true;
        }
    }
};
</script>

<style scoped>
video {
    width: 100% !important;
    height: auto !important;
}
</style>
